/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/Description",
  onChange
  
}) {
let scheduleNoteContentValueData = fromData.useDataValue({ viewPath,
context: 'schedule_note',
path: 'content',
})
let scheduleNoteContentChangeData = fromData.useDataChange({ viewPath,
context: 'schedule_note',
path: 'content',
})
let scheduleNoteTypeValueData = fromData.useDataValue({ viewPath,
context: 'schedule_note',
path: 'type',
})
let constantData = 'blockTime'
let aggregateData = fromAggregate.equals(scheduleNoteTypeValueData, constantData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 placeholder={aggregateData ? "Add a description / note as a reason for blocking time" : "Enter your note"}
 height={54}
 marginTop={dtSpaceXxs}
 data="schedule_note.content"
 onChange={scheduleNoteContentChangeData}
 value={scheduleNoteContentValueData}
 data="schedule_note.type"
 data="'blockTime'"
 aggregate="/Data/aggregate equals"
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Description"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
 borderColor={dtColorsNeutral200}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}